module.exports = {
    "breadcrumbs": `Breadcrumbs`
};


//# sourceMappingURL=de-DE.main.js.map
